"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var ColumnHeaderPopup = /** @class */ (function (_super) {
            __extends(ColumnHeaderPopup, _super);
            function ColumnHeaderPopup(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.IsSorted = $dyn.observable(-1);
                _this._parentRoot = parent ? parent.Root : undefined;
                _this.FilterExpressions = [];
                // data.DataSource is the headerMetadata pushed from grid
                if (data.DataSource) {
                    _this.IsSorted(data.DataSource.IsSorted);
                    _this.FormDataSourceName = data.DataSource.FormDataSourceName;
                    _this.FieldName = data.DataSource.FieldName;
                    _this.FilterExpressions = data.DataSource.FilterExpressions;
                    _this.controlType = $dyn.value(data.DataSource.ControlType);
                    _this.FlyOutPickerOpen = data.DataSource.FlyOutPickerOpen;
                    _this.controlName = data.DataSource.Name;
                    if (!_this._parentRoot && data.DataSource.Root) {
                        _this._parentRoot = data.DataSource.Root;
                    }
                }
                if (!_this.Root) {
                    _this.Root = _this._parentRoot;
                }
                // When Flyout picker closes and ShouldReturnFocus flag is set, then focus should get back to the control inside of the grid.
                $dyn.observe(_this.FlyOutPickerOpen, function (newValue) {
                    if (!$dyn.value(newValue) && _this.ShouldReturnFocus && _this._parentRoot && _this._parentRoot.setControlFocus && _this.controlName) {
                        _this._parentRoot.setControlFocus(_this.controlName);
                    }
                });
                _this.ButtonsEnabled = $dyn.computed(function () {
                    var isEnabled = false;
                    if (_this.FilterExpressions) {
                        var filterExpressions = $dyn.value(_this.FilterExpressions);
                        if (filterExpressions) {
                            filterExpressions.forEach(function (filterExpression) {
                                isEnabled = $dyn.util.stringToBoolean($dyn.value(filterExpression.IsEditable)) || isEnabled;
                            });
                        }
                    }
                    return isEnabled;
                });
                _this.AscendingLabel = $dyn.observable("");
                _this.DescendingLabel = $dyn.observable("");
                switch (_this.controlType) {
                    case $dyn.ui.ControlTypes.Integer:
                    case $dyn.ui.ControlTypes.Int64:
                    case $dyn.ui.ControlTypes.Real:
                        _this.AscendingLabel($dyn.label("List_IncSortNumber"));
                        _this.DescendingLabel($dyn.label("List_DecSortNumber"));
                        break;
                    case $dyn.ui.ControlTypes.Date:
                    case $dyn.ui.ControlTypes.DateTime:
                    case $dyn.ui.ControlTypes.Time:
                        _this.AscendingLabel($dyn.label("List_IncSortTime"));
                        _this.DescendingLabel($dyn.label("List_DecSortTime"));
                        break;
                    case $dyn.ui.ControlTypes.Enum:
                    case $dyn.ui.ControlTypes.ComboBox:
                        _this.AscendingLabel($dyn.label("List_IncSortEnum"));
                        _this.DescendingLabel($dyn.label("List_DecSortEnum"));
                        break;
                    default:
                        _this.AscendingLabel($dyn.label("List_IncSortString"));
                        _this.DescendingLabel($dyn.label("List_DecSortString"));
                        break;
                }
                _this.DescendingToggle = $dyn.computed(function () {
                    var curState = $dyn.value(_this.IsSorted);
                    return $dyn.value(curState) === $dyn.ui.SortDirection.descending ? true : false;
                });
                _this.AscendingToggle = $dyn.computed(function () {
                    var curState = $dyn.value(_this.IsSorted);
                    return $dyn.value(curState) === $dyn.ui.SortDirection.ascending ? true : false;
                });
                _this.SortAscending = function () {
                    _this.applySort(true);
                };
                _this.SortDescending = function () {
                    _this.applySort(false);
                };
                _this.applyFilters = function () {
                    _this.FilterManager.applyFieldFilters(_this.UnwrappedFilterExpressions(), _this.Name, $dyn.telemetry.ActionEvents.gridColumnFilter);
                    _this.ShouldReturnFocus = true;
                    _this.FlyOutPickerOpen(false);
                };
                _this.resetFilters = function () {
                    _this.FilterManager.resetFieldFilters(_this.UnwrappedFilterExpressions(), _this.Name, $dyn.telemetry.ActionEvents.gridColumnFilter);
                    _this.ShouldReturnFocus = true;
                    _this.FlyOutPickerOpen(false);
                };
                return _this;
            }
            Object.defineProperty(ColumnHeaderPopup.prototype, "FilterManager", {
                get: function () {
                    if (!this._filterManager && this._parentRoot) {
                        this._filterManager = this._parentRoot.FilterManager;
                    }
                    return this._filterManager;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Set an aria label on the column header that will describe the sorts and filters applied. Optionally simply clear the aria label
             * @param clearLabel Clear the aria-label of the column header
             */
            ColumnHeaderPopup.prototype.UpdateColumnHeaderAriaLabel = function (clearLabel) {
                if (clearLabel === void 0) { clearLabel = false; }
                var filterExpressions = $dyn.value(this.FilterExpressions);
                var sortDirection = $dyn.value($dyn.value(this.IsSorted));
                var ariaLabel = "";
                if (filterExpressions && filterExpressions.length && !clearLabel) {
                    var filterOpenedLabel = $dyn.label("FilterManager_ColumnFilterOpened");
                    var sortLabel = "";
                    switch (sortDirection) {
                        case $dyn.ui.SortDirection.ascending:
                            sortLabel = $dyn.label("FilterManager_SortedAscendingAria");
                            break;
                        case $dyn.ui.SortDirection.descending:
                            sortLabel = $dyn.label("FilterManager_SortedDescendingAria");
                            break;
                        default:
                            sortLabel = $dyn.label("FilterManager_UnsortedAria");
                    }
                    var expressionLabel_1 = $dyn.format($dyn.label("FilterManager_FilterCountAria"), filterExpressions.length);
                    filterExpressions.forEach(function (filterExpression) {
                        var capability = $dyn.value(filterExpression.Capability);
                        expressionLabel_1 += $dyn.util.getFilterFieldDescriptionAria(filterExpression, capability);
                    });
                    ariaLabel = filterOpenedLabel + " " + sortLabel + " " + expressionLabel_1;
                }
                var $inputControlElement = $(this.element);
                $inputControlElement.attr("aria-busy", "true");
                $inputControlElement.attr("aria-label", ariaLabel);
                $inputControlElement.attr("aria-busy", "false");
            };
            /**
             * Handles key down events within a ColumnHeaderPopup.
             * @param event The jQuery event for the key down.
             */
            ColumnHeaderPopup.prototype.processKeyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            ColumnHeaderPopup.prototype.setControlFocus = function (controlName) {
                var element = $dyn.ui.findControlElement(controlName, $dyn.ui.RootType.columnHeader);
                if (element) {
                    $dyn.log.focus && $dyn.log.focus("ColumnHeader setControlFocus - setting focus to control %s", controlName);
                    $dyn.util.focusElement(element);
                }
            };
            ColumnHeaderPopup.prototype.HandleEnter = function (event) {
                if (this.element) {
                    var targetElement = event.target;
                    // If the target element is an input element within the columnHeaderPopup, apply filters.
                    if (targetElement && targetElement.tagName && targetElement.tagName.toLowerCase() === "input" && $.contains(this.element, targetElement)) {
                        this.applyFilters();
                        return true;
                    }
                }
                return false;
            };
            ColumnHeaderPopup.prototype.HandleEscape = function (event) {
                this.ShouldReturnFocus = true;
                return false;
            };
            ColumnHeaderPopup.prototype.UnwrappedFilterExpressions = function () {
                var filterExpressions = $dyn.value(this.FilterExpressions);
                var unwrappedFilterExpressions = [];
                if (filterExpressions) {
                    filterExpressions.forEach(function (filterExpression) {
                        unwrappedFilterExpressions.push($dyn.util.unwrapFilterExpression(filterExpression));
                    });
                }
                return unwrappedFilterExpressions;
            };
            ColumnHeaderPopup.prototype.applySort = function (isAscending) {
                var sort = [];
                sort.push(this.UnwrappedFilterExpressions());
                var sortLabel;
                if (isAscending) {
                    sort.push("1");
                    sortLabel = $dyn.value(this.AscendingLabel);
                }
                else {
                    sort.push("0");
                    sortLabel = $dyn.value(this.DescendingLabel);
                }
                // set clear sorts to 1
                sort.push("1");
                if ($dyn.value($dyn.ax.taskRecording.isRecording())) {
                    sort.push(this.Name);
                    sort.push(sortLabel);
                }
                this.FilterManager.setFieldSorts(sort, $dyn.telemetry.ActionEvents.gridColumnSort);
                this.ShouldReturnFocus = true;
                this.FlyOutPickerOpen(false);
            };
            return ColumnHeaderPopup;
        }(controls.ProtoForm));
        controls.ColumnHeaderPopup = ColumnHeaderPopup;
        ColumnHeaderPopup.prototype.FormDataSourceName = "";
        ColumnHeaderPopup.prototype.FieldName = "";
        ColumnHeaderPopup.prototype.Name = "";
        ColumnHeaderPopup.prototype.IsSorted = -1;
        ColumnHeaderPopup.prototype.applyFilters = null;
        ColumnHeaderPopup.prototype.resetFilters = null;
        ColumnHeaderPopup.prototype.Label = "";
        ColumnHeaderPopup.prototype.AscendingLabel = "List_IncSortString";
        ColumnHeaderPopup.prototype.DescendingLabel = "List_DecSortString";
        ColumnHeaderPopup.prototype.ShouldReturnFocus = false;
        // tslint:disable:object-literal-sort-keys
        var columnHeaderPopupShortcuts = {
            applyFilter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    return this.HandleEnter(evt);
                },
                Description: "Apply filter",
            },
            escapeHandling: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    return this.HandleEscape(evt);
                },
                Description: "Close column filtering",
                Category: $dyn.ui.ShortcutCategory.Close
            },
        };
        ColumnHeaderPopup.prototype.Shortcuts = $dyn.extendPrototype(ColumnHeaderPopup.prototype.Shortcuts, columnHeaderPopupShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ColumnHeaderPopup.js.map
